import { type ReactElement } from 'react';
import { ArrowRight, Shield, CreditCard, Clock } from 'lucide-react';

const benefits = [
  { icon: Clock, text: '14 Tage kostenlos testen' },
  { icon: CreditCard, text: 'Keine Kreditkarte erforderlich' },
  { icon: Shield, text: 'Jederzeit kündbar' },
];

export default function CallToAction(): ReactElement {
  return (
    <section className="py-20 lg:py-32 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800" />

      {/* Pattern Overlay */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      />

      {/* Floating Shapes */}
      <div className="absolute top-10 left-10 w-20 h-20 bg-white/10 rounded-full blur-xl" />
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-white/10 rounded-full blur-xl" />
      <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-white/5 rounded-full blur-lg" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative text-center">
        {/* Keine Nutzerzahl: "Über 10.000 Unternehmen" war frei erfunden.
            Falsche Zahlen sind irrefuehrende Werbung (§ 5 UWG) und fliegen
            auf. Stattdessen eine Aussage, die nachpruefbar stimmt. */}
        <div className="mb-8 inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-2 text-sm font-medium text-white backdrop-blur-sm">
          Entwickelt und gehostet in Deutschland
        </div>

        {/* Main Headline */}
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
          Starten Sie jetzt kostenlos mit Saldify
        </h2>

        {/* Subheadline */}
        <p className="text-lg sm:text-xl text-primary-100 mb-10 max-w-2xl mx-auto">
          Erleben Sie, wie einfach Buchhaltung sein kann. Registrieren Sie sich in
          weniger als 2 Minuten und erstellen Sie Ihre erste Rechnung noch heute.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <a
            href="#signup"
            className="inline-flex items-center justify-center gap-2 bg-white text-primary-700 px-8 py-4 rounded-lg text-base font-semibold shadow-xl hover:bg-primary-50 hover:-translate-y-0.5 transition-all group"
          >
            Kostenlos starten
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
          <a
            href="#demo"
            className="inline-flex items-center justify-center gap-2 bg-transparent text-white border-2 border-white/30 px-8 py-4 rounded-lg text-base font-semibold hover:bg-white/10 hover:-translate-y-0.5 transition-all"
          >
            Live-Demo anfordern
          </a>
        </div>

        {/* Benefits */}
        <div className="flex flex-wrap justify-center gap-6 lg:gap-10">
          {benefits.map((benefit) => (
            <div
              key={benefit.text}
              className="flex items-center gap-2 text-primary-100"
            >
              <benefit.icon className="w-5 h-5" />
              <span className="text-sm font-medium">{benefit.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
